import { useQuery } from "@tanstack/react-query";
import { getProfile, getBalance, getDeposits, getDepositHistory,getPayoutHistory, getKycDocs, getMyReferrals, getLoanAgreements} from "../userApi";

const useProfile = () => {
  return useQuery({
    queryFn: getProfile,
    queryKey: ["profile"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

const useBalance = () => {
  return useQuery({
    queryFn: getBalance,
    queryKey: ["balance"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

const useDeposits = () => {
  return useQuery({
    queryFn: getDeposits,
    queryKey: ["deposits"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
const useDepositHistory = () => {
  return useQuery({
    queryFn: getDepositHistory,
    queryKey: ["depositHistoryData"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
const usePayoutHistory = () => {
  return useQuery({
    queryFn: getPayoutHistory,
    queryKey: ["payoutHistory"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}

// get kyc docs
const useKYCDocs = () => {
  return useQuery({
    queryFn: getKycDocs,
    queryKey: ["kycDocs"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

// my referrals
const useMyReferrals = () => {
  return useQuery({
    queryFn: getMyReferrals,
    queryKey: ["myReferrals"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

// Hook to get loan agreements
const useLoanAgreements = () => {
  return useQuery({
    queryFn: getLoanAgreements,
    queryKey: ["LoanAgreements"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

export { useProfile, useBalance, useDeposits, useDepositHistory, usePayoutHistory, useKYCDocs, useMyReferrals, useLoanAgreements };
